import { useContext, useEffect, useState } from "react";
import { trackGoal } from "../helpers/tracker";
import UserAvatar, { openPassport } from "../mainscreen/header/Avatar";
import HeaderLogo from "../mainscreen/HeaderLogo";
import '../mainscreen/MainScreen.css'
import { ReferralAppContext } from "./ReferralApp";

interface IReferralHeaderProps {
    avatarUrl: string,
    name: string,
}

export default function ReferralHeader(props: IReferralHeaderProps) {
    const [active, setActive] = useState(false);
    const [translate, setTranslate] = useState(0);
    const isLoggedIn = useContext(ReferralAppContext)?.isLoggedIn ?? false;

    // @ts-ignore
    const handleScroll = (event) => {
        const scroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        setTranslate(Math.min(-scroll, 0));
        if (scroll > 72 * 2) {
            setTranslate(0);
            setActive(true);
        } else {
            setActive(false);
            setTranslate(Math.min(-(Math.min(176, scroll)), 0));
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    return (
        <div className={"Referral_header"}>
            <div
                className={"Header_links" + (active ? " Header_links_fixed" : "") + (active ? " Header_active" : "")}>
                <HeaderLogo isLarge={true} />
                <div className="Header_Menu">
                    <a href="https://yandex.ru/drive/" className="Header_Menu_Item_Selected">Каршеринг</a>
                    <a href="https://yandex.ru/drive/podpiska" className="Header_Menu_Item">Подписка</a>
                    <a href="https://yandex.ru/drive/b2b" className="Header_Menu_Item">Для бизнеса</a>
                </div>
                <div className="Header_Avatar_Container">
                    <div className="Header_Avatar_Title" style={{cursor: "pointer"}} onClick={() => { 
                        openPassport();
                        if (!isLoggedIn) {
                            trackGoal("referral_cabinet_login");
                        }
                    }}>
                        {isLoggedIn ? props.name : "Войти"}
                    </div>
                    {
                        isLoggedIn && <UserAvatar url={props.avatarUrl} styleClass={"Header_Avatar_Image"} />
                    }
                </div>
            </div>
        </div>
    );
}